import { JsonObject } from '../app/json/jsonObject.js';
import { ResourceStatistics } from './resourceStatistics.js';

export class TemplateEntry {
    html: string;
    json: JsonObject | null;

    constructor(html: string = '', json: JsonObject | null = null) {
        this.html = html;
        this.json = json;
    }

}

type TemplateStoreMap = Map<string, TemplateEntry>;

export class TemplateStore {
    private _appSiteCache: Map<string, TemplateStoreMap> = new Map();
    private _resourceStatsCache: Map<string, ResourceStatistics> = new Map();

    hasAppSite(appSite: string): boolean {
        return this._appSiteCache.has(appSite);
    }

    tryGetTemplates(appSite: string): TemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    getTemplates(appSite: string): TemplateStoreMap {
        const templates = this._appSiteCache.get(appSite);
        if (!templates) throw new Error(`AppSite '${appSite}' is not loaded.`);
        return templates;
    }

    addAppSite(appSite: string, templates: TemplateStoreMap): boolean {
        if (!this._appSiteCache.has(appSite)) {
            this._appSiteCache.set(appSite, templates);
            return true;
        }
        return false;
    }

    getAllAppSites(): Map<string, TemplateStoreMap> {
        return this._appSiteCache;
    }

    tryGetResourceStats(appSite: string): ResourceStatistics | undefined {
        if (!this._resourceStatsCache.has(appSite)) {
            return undefined;
        }

        return this._resourceStatsCache.get(appSite);
    }

    setResourceStats(appSite: string, stats: ResourceStatistics): void {
        this._resourceStatsCache.set(appSite, stats);
    }
}
